import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { Component, JSX, Show, createMemo } from 'solid-js';

export interface FxWorkspaceReferenceSaveButtonProps {
  readonly workspaceId: string;
  readonly refTrn: string;
}

export const FxWorkspaceReferenceSaveButton: Component<
  FxWorkspaceReferenceSaveButtonProps
> = (props): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const isSaved = createMemo(() =>
    fxWorkspace.isReferenceVisible(props.workspaceId, props.refTrn)
  );

  const actionLabel = createMemo(() =>
    isSaved()
      ? t('mobileMapping.fxWorkspace.references.saved')
      : t('mobileMapping.fxWorkspace.references.save')
  );

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handleToggle = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.toggleReferenceVisibility(props.workspaceId, props.refTrn);
  };

  return (
    <button
      type="button"
      class="inline-flex h-8 w-8 items-center justify-center rounded hover:bg-background-secondary"
      aria-label={actionLabel()}
      title={actionLabel()}
      data-testid={`fx-workspace-reference-save-button-${props.workspaceId}-${props.refTrn}`}
      data-saved={isSaved() ? 'true' : 'false'}
      onClick={handleToggle}
      onPointerDown={stopTreeRowInteraction}
    >
      <Show
        when={isSaved()}
        fallback={
          <i
            class="icon-font tc-icon-save i16 text-icon-primary"
            aria-hidden="true"
          />
        }
      >
        <i
          class="icon-font tc-icon-bookmark i16 text-primary"
          aria-hidden="true"
        />
      </Show>
    </button>
  );
};
